import { FirestoreError } from "@firebase/firestore-types";

export const isFirestoreError = function (error: any): error is FirestoreError {
  return (
    error instanceof Object &&
    error.hasOwnProperty("name") &&
    error.name === "FirebaseError"
  );
};
